import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Missisipiimages from "../../Media/Kotwis/Missisipi/Missisipi";
import Davinciimages from "../../Media/Kotwis/Davinci/Davinci";
import Aethertonimages from "../../Media/Kotwis/Aetherton/Aetherton";
import Vermontimages from "../../Media/Kotwis/Vermont/Vermont";
import Averonimages from "../../Media/Kotwis/Averon/Averon 10/Averon10";
import Richmondimages from "../../Media/Kotwis/Richmond/Richmond";

const imageMap = {
  Missisipiimages,
  Davinciimages,
  Aethertonimages,
  Vermontimages,
  Richmondimages,
  Averonimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="produk" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
